import { $transferRequestsDeleteFileStore, $transferRequestsUploadFileStore } from '@lib/store';
import type { CustomFile, FileWithId } from '@shared/widgets';

export class PaymentUtils {
  static uploadPaymentDocuments = async (data: { transferRequestId: string; files: (FileWithId | CustomFile)[] }) => {
    const result = [];

    for (const file of data.files) {
      if ('file' in file) {
        result.push(file);
        continue;
      }

      const response = await $transferRequestsUploadFileStore.events.createDocument({ transferRequestId: data.transferRequestId, file: file });

      const uploadedFile = {
        id: response.data || '',
        name: file.name,
        type: file.type,
        file: file as unknown as File,
      };

      result.push(uploadedFile);
    }

    return result;
  };

  static deletePaymentDocument = async (data: { transferRequestId?: string; files: (FileWithId | CustomFile)[]; file: FileWithId | CustomFile }) => {
    if (data.transferRequestId && data.file.id)
      await $transferRequestsDeleteFileStore.events.update({ TransferRequestId: data.transferRequestId, DocumentId: data.file.id });

    return data.files.filter((file) => {
      if (data.file.id) return 'id' in file ? file.id !== data.file.id : true;
      return file.name !== data.file.name;
    });
  };
}
